import classNames from 'classnames';
import React, { memo, useCallback } from 'react';
import { playCardClickSound } from '@wg/web2clientapi/sound';

import { isInGame } from '~/constants';
import { useAppDispatch } from '~/store';
import { closeSupplySidebarThunk } from '~/store/thunks/supplyThunks';
import { actionsSupply } from '~/Actions/ActionSupply';

import styles from './SidebarToggleButton.module.scss';

type IProps = {
  className?: string;
  isSidebarOpened: boolean;
};

const SidebarToggleButton: React.FC<IProps> = ({ className, isSidebarOpened }) => {
  const dispatch = useAppDispatch();

  const openSidebarButton = classNames(styles.openSidebarButton, className, {
    [styles.closeSidebarButton]: isSidebarOpened,
    [styles.inGame]: isInGame,
  });

  const handleClick = useCallback(() => {
    void playCardClickSound();

    if (isSidebarOpened) {
      dispatch(closeSupplySidebarThunk());
    } else {
      dispatch(actionsSupply.openSupplySidebar());
    }
  }, [dispatch, isSidebarOpened]);

  return (
    <div className={openSidebarButton} onClick={handleClick}>
      <div className={isSidebarOpened ? styles.sidebarButtonIconClose : styles.sidebarButtonIconBuilding} />
    </div>
  );
};

export default memo(SidebarToggleButton);
